<template>
  <v-app>
    <Snackbar />
    <Sidebar />
    <Toolbar />
    <v-main class="blue-grey lighten-4">
      <transition name="slide" mode="out-in">
        <router-view />
      </transition>
    </v-main>
    <v-overlay :value="loading" z-index="1000">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-app>
</template>

<script>
import Sidebar from '@/components/Sidebar.vue'
import Snackbar from '@/components/Snackbar.vue'
import Toolbar from '@/components/Toolbar.vue'

export default {
  name: 'App',
  components: {
    Snackbar,
    Sidebar,
    Toolbar,
  },
  computed: {
    loading() {
      return this.$store.state.loading
    },
  },
}
</script>

<style>
@import './assets/css/fonts-face.css';

/* router view animation */
.slide-enter-active {
  animation: slide-in 200ms ease-out forwards;
}

.slide-leave-active {
  animation: slide-out 200ms ease-out forwards;
}

@keyframes slide-in {
  from {
    transform: translateY(-30px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes slide-out {
  from {
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform: translateY(-30px);
    opacity: 0;
  }
}
/* end router view animation */

/* Default CSS */
#app {
  font-family: 'NotoSansThai', Arial, Helvetica, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Overline CSS */
.v-application .title,
.v-application .body-1,
.v-application .body-2,
.v-application .text-h5,
.v-application .caption {
  font-family: 'NotoSansThai', Arial, Helvetica, sans-serif !important;
}

.v-data-footer {
  justify-content: flex-start !important;
  padding: 0 20px;
}
.v-messages__message {
  line-height: 16px !important;
}

/* Custom CSS */
.v-navigation-drawer.main-side-bar {
  background: linear-gradient(180deg, #1867c0, #5cbbf6);
}

.row-selected {
  background-color: #cfd8dc;
}

.cursor-pointer {
  cursor: pointer;
}

.cursor-not-allowed {
  cursor: not-allowed;
}

/* Fix google chrome pointer event */
.fix-google-chrome.v-autocomplete:not(
    .v-input--is-disabled
  ).v-select.v-text-field
  input {
  /* pointer-events: none !important; */
  line-height: normal;
}
.fix-google-chrome.v-text-field input {
  /* pointer-events: none !important; */
  line-height: normal;
}

.btn-link:hover {
  text-decoration: underline;
}

button:disabled,
button[disabled] {
  cursor: not-allowed;
}
</style>
